import {
  role_map,
  template_type_single,
  theme_type_color
} from '@/const.js'
import util from '@/util'
import fontService from '../../request/service/font-service'
import materialService from '../../request/service/material-service'
import projectService from '../../request/service/project-service'
import templateService from '../../request/service/template-service'
import userService from '../../request/service/user-service'

const app = {
  namespaced: true,
  state: {
    clientSize: {
      width: 0,
      height: 0
    },
    projectId: null,
    adminProjects: [],
    projects: [],
    activeProjectRole: {
      role: null,
      roleName: null
    },
    categoryList: [],
    loginUser: {
      blankTemplateId: '',
      feeNotice: false,
      surveyUrl: '',
      ads: [], //投放信息
      email: '',
      id: '',
      mobile: '',
      name: '',
      isNovice: false, //是否出现新手引导
      projectApplyList: [], //登录人正在申请的项目id列表 ['xxxx']
      projectItems: [], // 登录人可以访问的所有项目列表 [{id: xxx, name: xxx}]
      role: '', // 用户角色，空为普通角色， SYS_ADMIN系统管理员
      projectRoles: [], // {projectId: xxx, role: 'proj_admin'} 项目角色
      publicProject: { id: null },
      preliminaryProject: {},
      aigcProjectId: '',
      dubheAiVisible:false // AI入口是否可见
    },
    saveAllTemplate: false,
    templateArray: [],
    materialArray: [],
    bgImgArray: [],
    editorSelectedImgIdx: null,
    imgViewLoading: false,
    bgColorArray: [],
    templateTags: [],
    templateIndexTags: [],
    materialTags: [],
    templateGroups: [],
    projectFontList: [],
    allFontObj: {},
    templateGroupsAll: [], // 模板联动组
    fontParams: {
      languages: [],
      makers: [],
      platforms: [],
      types: []
    },
    projectSet: {},
    publicTemplateId: null // 当前路由中的模板id,主要判断当前编辑页的模板是否是公共模板
  },
  getters: {
    projectId: (state) => state.projectId,
    projects: (state) => state.projects,
    clientHeight: (state) => state.clientSize.height,
    clientWidth: (state) => state.clientSize.width,
    isProjectUser (state) {
      let role = state.activeProjectRole
      return role.role === 'PROJ_USER'
    },
    isProjectAdmin (state) {
      let role = state.activeProjectRole
      return role.role === 'PROJ_ADMIN'
    },
    isAdmin (state) {
      let role = state.activeProjectRole
      return role.role === 'PROJ_ADMIN' || state.loginUser.role === 'SYS_ADMIN'
    },
    aigcProjectId: (state) => state.loginUser.aigcProjectId,
    canUpload (state) {
      return state.loginUser.role === 'PROJ_ADMIN' || state.loginUser.role === 'SYS_ADMIN'
    },
    isSYSAdmin (state) {
      return state.loginUser.role === 'SYS_ADMIN'
    },
    blankTemplateId (state) {
      return state.loginUser.blankTemplateId
    },
    isStudyCP (state) {
      // 云课堂cp用户
      return state.loginUser.email.indexOf('@cp.study.163.com') > -1
    },
    fixTplVisible (state) {
      return state.projectSet.SHOW_FIXED_TEMPLATE === 'ON'
    },
    freeTplVisible (state) {
      return state.projectSet.SHOW_FREE_TEMPLATE === 'ON'
    },
    publicResourceVisible (state) {
      return state.projectSet.SHOW_PUBLIC_PROJECT === 'ON'
    },
    freeTplUploaderVisible (state) {
      return state.projectSet.UPLOAD_FREE_TEMPLATE === 'ON'
    },
    fixTplUploaderVisible (state) {
      return state.projectSet.UPLOAD_FIXED_TEMPLATE === 'ON'
    },
    contactAs (state) {
      let data = state.projectSet.CONNECT_TO
      data = JSON.parse(data) || {}
      if (data.aSwitch === 'ON' && data.connectTo) {
        return data.connectTo
      }
      return ''
    },
    tipsAs (state) {
      return state.loginUser.feeNotice
    },
    surveyUrl (state) {
      return state.loginUser.surveyUrl
    },
    teamWorkVisible (state) {
      let isSysAdmin = state.loginUser.role === 'SYS_ADMIN'
      let switchOn = state.projectSet.SHOW_TEAM_WORK === 'ON'
      return isSysAdmin || switchOn
    },
    yanXuanMaterialVisible (state) {
      return state.projectSet.YANXUAN_PIC_QUERY === 'ON'
    },
    publicProjectId (state) {
      return state.loginUser.publicProject.id
    },
    // 获取项目类目
    categoryList (state) {
      return state.categoryList
    }
  },
  mutations: {
    set_surveyUrl (state, url) {
      state.loginUser.surveyUrl = url
    },
    set_login_user (state, user) {
      state.loginUser = user
    },
    set_user_projects (state, projects) {
      state.projects = projects
    },
    set_active_project_role (state, role) {
      state.activeProjectRole.role = role
      state.activeProjectRole.roleName = role_map[role]
    },
    set_admin_projects (state, projects) {
      state.adminProjects = projects
    },
    del_admin_projects (state, index) {
      state.adminProjects.splice(index, 1)
    },
    set_active_project (state, projectId) {
      state.projectId = projectId
      let arr = state.loginUser.projectItems.filter(item => {
        return item.id === projectId
      })
      if (arr && arr.length > 0) {
        state.projectSet = arr[0].settings
      }
    },
    set_template_save (state, trueOrFalse) {
      state.saveAllTemplate = trueOrFalse
    },
    set_template_array (state, data) {
      state.templateArray = data
    },
    set_material_array (state, data) {
      state.materialArray = data
    },
    set_bg_img_array (state, data) {
      state.bgImgArray = data
    },
    set_selected_img_index (state, index) {
      state.editorSelectedImgIdx = index
    },
    export_template_loading (state, trueOrFalse) {
      state.imgViewLoading = trueOrFalse
    },
    set_bg_colors (state, array) {
      state.bgColorArray = array
    },
    set_template_tags (state, array) {
      state.templateTags = array
    },
    set_template_index_tags (state, array) {
      state.templateIndexTags = array
    },
    set_template_category_list (state, array) {
      state.categoryList = array
    },
    set_material_tags (state, array) {
      state.materialTags = array
    },
    set_template_groups (state, array) {
      state.templateGroups = array
    },
    set_all_groups (state, array) {
      state.templateGroupsAll = array
    },
    set_user_guide (state, trueOrFalse) {
      state.loginUser.isNovice = trueOrFalse
    },
    set_project_fonts (state, data) {
      let { projFont, sysFont } = data
      state.projectFontList = [...projFont, ...sysFont]
      state.allFontObj = data
    },
    del_ads (state, id) {
      if (id) {
        state.loginUser.ads = state.loginUser.ads.filter(item => {
          return item.id !== id
        })
      } else {
        state.loginUser.ads = []
      }
    },
    set_public_templateId (state, templateId) {
      state.publicTemplateId = templateId
    },
    set_client_size (state, payload) {
      state.clientSize.height = payload.height
      state.clientSize.width = payload.width
    },
  },
  actions: {
    setSurveyUrl ({ commit }, payload) {
      commit('set_surveyUrl', payload)
    },
    setClientSize ({ commit }) {
      const payload = {
        width: document.body.clientWidth,
        height: document.body.clientHeight
      }
      commit('set_client_size', payload)
    },
    queryLoginUserInfo ({ commit }, urlProjectId) {
      return userService.getUserInfo().then(data => {
        commit('set_login_user', data)
        util.setActiveProject(
          data.projectItems,
          urlProjectId,
          commit,
          data.projectRoles,
          data.role
        )
        return data
      })
    },
    queryLoginUserProjects ({ commit }) {
      return projectService.getLoginUserProjects().then(data => {
        commit('set_user_projects', data)
        return data
      })
    },
    queryAdminProjects ({ commit }) {
      return projectService.getAdminProjects().then(data => {
        commit('set_admin_projects', data)
        return data
      })
    },
    queryBgColorList ({ commit }, { projectId, tplGroupIds }) {
      return materialService
        .getBgColorList(projectId, theme_type_color, tplGroupIds)
        .then(data => {
          commit('set_bg_colors', data)
          return data
        })
    },
    queryTemplateIndexTagList ({ commit }, projectId) {
      return templateService.getTemplateIndexTags(projectId).then(data => {
        commit('set_template_index_tags', data)
        return data
      })
    },
    getTplCategoryList ({ commit }, projectId) {
      return templateService.getTemplateCategory(projectId).then(data => {
        commit('set_template_category_list', data)
        return data
      })
    },
    queryTemplateTagList ({ commit }, projectId) {
      return templateService.getTemplateTags(projectId).then(data => {
        commit('set_template_tags', data)
        return data
      })
    },
    queryTemplateGroup ({ commit }, { projectId, type }) {
      type = type ? type : template_type_single
      return templateService
        .getTemplateGroupByProjectId(projectId, type)
        .then(data => {
          let array = []
          data.forEach(v => {
            if (!v.isDefault) {
              array.push({
                value: v.name,
                id: v.id
              })
            }
          })
          commit('set_template_groups', array)
        })
    },
    queryTemplateGroupAll ({ commit }, projectId) {
      return templateService
        .getTemplateGroupByProjectId(projectId, '')
        .then(data => {
          let array = []
          data.forEach(v => {
            if (!v.isDefault) {
              array.push({
                value: v.name,
                id: v.id
              })
            }
          })
          commit('set_all_groups', array)
        })
    },
    queryMaterialTags ({ commit }, projectId) {
      return materialService.getMaterialTag(projectId).then(data => {
        commit('set_material_tags', data)
      })
    },
    queryFontList ({ commit, state }, { projectId, fontNameList = [] }) {
      return fontService
        .getFontsByProjectId(projectId, fontNameList)
        .then(data => {
          data.projFont &&
            data.projFont.forEach(item => {
              item.originName = item.name
            })
          data.sysFont &&
            data.sysFont.forEach(item => {
              item.originName = item.name
            })
          commit('set_project_fonts', data)
        })
    }
  }
}
export default app
